import React from 'react'
import "./ServicesCarasoul.css"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import {Autoplay} from "swiper/modules"
import ServiceCard from './serviceCard';





function ServicesCarasoul({
    serviceData
}) {



    const handlePrevButtonClick = () => {
        const swiperInstance = document.querySelector('#service-cards-slider').swiper;
        swiperInstance.slidePrev();
      };
      
      const handleNextButtonClick = () => {
        const swiperInstance = document.querySelector('#service-cards-slider').swiper;
        swiperInstance.slideNext();
      };
  return (
    <div className='ServicesCarasoul-container '>
        <div className='container mt-3'>


                <Swiper
                    spaceBetween={60}
                    autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                    }}
                    loop={true}
                    // modules={[Autoplay]}
                    navigation={
                        {
                          nextEl: '.swiper-button-next',
                          prevEl: '.swiper-button-prev',
                        }
                        }
                    breakpoints={{
                        200:{
                        slidesPerView: 1,
                        },
                        1100: {
                        slidesPerView: 3,
                        }
                    }}
                    pagination={{ clickable: true }}
                    observer ={true}
                    observeParents={true}
                    parallax={true}
                    className=" px-3 px-md-5 py-4"
                    style={{position:"relative"}}
                    id="service-cards-slider"
                    >
                    
                    
                <div className="swiper-button-prev swiper-button d-lg-block d-none" onClick={handlePrevButtonClick}> 
                <img src="/images/icons/indus-carousel-arrow-left.png" className="arrow-img"/>
                </div>
                {
                        serviceData.map((ele,ind)=>{
                        return(<>
                            <SwiperSlide>
                                <ServiceCard
                                    icon={ele.icon}
                                    iconBox={ele?.iconBox}
                                    heading={ele.heading}
                                    content={ele.content}
                                    btnText={ele.btnText}
                                    btnRef={ele.btnRef}
                            
                                />
                            </SwiperSlide>
        
                            </>)
                        })
                    }
                    <div className="swiper-button-next swiper-button d-lg-block d-none" onClick={handleNextButtonClick}>
                    <img src="/images/icons/indus-carousel-arrow-right.png" className="arrow-img"/>
                    </div>
                </Swiper>
                </div>
    </div>

  )
}

export default ServicesCarasoul